import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  TouchableOpacity,
  View,
  Keyboard,
} from 'react-native';
import {
  Text,
} from 'react-native-elements';

import { translate } from '../../locales/i18n';
import styles from '../../styles';

class Header extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { name } = this.props;

    console.log('Header:', name);
  }

  render() {
    const {
      name,
      hasCancel,
      onCancel,
      hasBack,
    } = this.props;

    return (
      <View
        style={styles.view.headerContainer}
      >
        <View
          style={styles.view.header}
        />
        <View
          style={styles.view.headerCenterContainer}
        >
          <View
            style={styles.view.headerCenter}
          >
            <Text
              style={styles.view.headerCenter}
              numberOfLines={1}
              ellipsizeMode="tail"
              onPress={Keyboard.dismiss}
              onTouchStart={Keyboard.dismiss}
            >
              {name}
            </Text>
          </View>
        </View>
        {hasCancel && (
          <View
            style={styles.view.headerRightContainer}
          >
            <TouchableOpacity
              style={{
              }}
              onPress={() => {
                const { history } = this.props;

                console.log('onPress');

                console.log('onCancel');
                console.log(onCancel);
                console.log('history');
                console.log(history);

                if (onCancel) {
                  onCancel();
                  return;
                }

                history.push('/ai-agents');
              }}
            >
              <Text
                style={styles.view.headerRight}
              >
                {translate('button_cancel')}
              </Text>
            </TouchableOpacity>
          </View>
        )}
        {hasBack && (
          <View
            style={styles.view.headerRightContainer}
          >
            <TouchableOpacity
              style={{
              }}
              onPress={() => {
                const { history } = this.props;

                history.go(-1);
              }}
            >
              <Text
                style={styles.view.headerRight}
              >
                {translate('button_back')}
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    );
  }
}

Header.defaultProps = {
  hasCancel: false,
  onCancel: undefined,
  hasBack: false,
};

Header.propTypes = {
  name: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  hasCancel: PropTypes.bool,
  onCancel: PropTypes.func,
  hasBack: PropTypes.bool,
};

export default Header;
